<div class="no-device-wrapper">
  <p class="no-device-text" i18n="@@noDevicesfound">
    There are no devices attached to this plan
  </p>
</div>
